import React from 'react';
import { useRouter } from 'next/router';
import { useTerms } from '@repository/terms/useTerms';

import classnames from 'classnames/bind';
import styles from './thirdpartyAgreement.module.scss';

const cx = classnames.bind(styles);

const ThirdpartyAgreement = () => {
  const { data: termsData } = useTerms({ termType: 'RESUME_PRIVACY_PROVISION' });
  const { query } = useRouter();

  if (!termsData || !termsData.length) return null;

  const companyName = query?.companyName ?? '';
  const title = termsData[0].title ?? '';
  const contents =
    termsData[0].contents.replace(/(\$고객사\$)|(\$기업명\$)|(\$입사지원 기업\$)/g, `${companyName}`) ?? '';

  return (
    <div className={cx('wrap')}>
      <div className={cx('titleArea')}>
        <strong className={cx('title')}>{title}</strong>
      </div>

      <div className={cx('infoArea')}>
        <div dangerouslySetInnerHTML={{ __html: contents }} />
      </div>
    </div>
  );
};

export default ThirdpartyAgreement;
